<nav class="breadcrumb" aria-label="breadcrumb">
  <ol>
    <li>
      <a [routerLink]="['/']">
        <mat-icon inline>explore</mat-icon>
      </a>
    </li>
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <mat-icon inline>chevron_right</mat-icon>
      <a 
        [routerLink]="[breadcrumb.url]"
        [class.active]="last">
        {{ breadcrumb.label }}
      </a>
    </li>
  </ol>
</nav>
